import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  displayUrlResolver,
  isMediaDocResolver,
  mediaUrlsResolver,
  mentionedUrlsResolver
} from './mentionedUrl'

const streamDataFieldResolvers: FieldResolver[] = [
  displayUrlResolver,
  isMediaDocResolver,
  mediaUrlsResolver,
  mentionedUrlsResolver
]

const mentionedUrlRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default mentionedUrlRelatedFieldsResolver
